var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.load)?_c('div',{staticClass:"dropdown bounceIn"},[_c('transition',{attrs:{"name":"slide-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:"dropdown",class:{ 'is-touch': _vm.isTouchDevice },on:{"mouseover":_vm.triggerShow,"mouseout":_vm.triggerClose}},[_vm._t("default")],2)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }